import type { ModuleManifest } from "./types";

export const productsManifest: ModuleManifest = {
  name: "products",
  label: "Product",
  labelPlural: "Products",

  coreBOSModule: "Products",
  wsidPrefix: "14x",

  type: "standard",

  routes: {
    list: "/products",
    show: "/products/show/:id",
    create: "/products/create",
    edit: "/products/edit/:id",
  },

  navigation: {
    icon: "ShoppingOutlined",
    order: 10,
    group: "Inventory",
  },

  routing: {
    keywords: [
      "product",
      "products",
      "item",
      "items",
      "inventory",
      "stock",
      "sku",
    ],
    searchFields: ["productname", "productcode"],
    defaultSort: { field: "productname", order: "asc" },
  },

  context: {
    supported: true,
    entityKey: "products",
  },

  fields: [
    {
      name: "productname",
      label: "Product Name",
      type: "string",
      required: true,
    },
    { name: "productcode", label: "Product Code", type: "string" },
    { name: "product_no", label: "Product No", type: "string", readonly: true },
    {
      name: "productcategory",
      label: "Category",
      type: "picklist",
      options: [
        { value: "Hardware", label: "Hardware" },
        { value: "Software", label: "Software" },
        { value: "CRM Applications", label: "CRM Applications" },
      ],
    },
    { name: "manufacturer", label: "Manufacturer", type: "picklist" },
    {
      name: "vendor_id",
      label: "Vendor",
      type: "reference",
      referenceModule: "Vendors",
    },
    {
      name: "unit_price",
      label: "Unit Price",
      type: "currency",
      required: true,
    },
    { name: "cost_price", label: "Cost Price", type: "currency" },
    {
      name: "usageunit",
      label: "Usage Unit",
      type: "picklist",
      options: [
        { value: "Pcs", label: "Pieces" },
        { value: "Hours", label: "Hours" },
        { value: "Days", label: "Days" },
      ],
    },
    {
      name: "qty_per_unit",
      label: "Qty/Unit",
      type: "number",
      defaultValue: 1,
    },
    { name: "qtyinstock", label: "Qty in Stock", type: "number" },
    { name: "reorderlevel", label: "Reorder Level", type: "number" },
    { name: "qtyindemand", label: "Qty in Demand", type: "number" },
    { name: "glacct", label: "GL Account", type: "picklist" },
    { name: "productsheet", label: "Product Sheet", type: "string" },
    { name: "website", label: "Website", type: "string" },
    { name: "description", label: "Description", type: "text" },
    {
      name: "discontinued",
      label: "Discontinued",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Vendors",
      field: "vendor_id",
      label: "Vendor",
      icon: "ShopOutlined",
      displayField: "vendorname",
    },
    {
      module: "PriceBooks",
      relation: "many-to-many",
      label: "Price Books",
      icon: "DollarOutlined",
      displayField: "bookname",
    },
  ],

  requiredFields: ["productname", "unit_price", "assigned_user_id"],

  // Mass edit - fields are dynamically loaded from filterFields
  massEdit: {
    enabled: true,
  },
};
